import React, { useState } from 'react';
import { CalendarCheck, ClockCounterClockwise, Users, SignOut, List, X } from '@phosphor-icons/react';
import OnPowerLogo from '../../../shared/components/brand/OnPowerLogo';
import OnPowerLogoIcon from '../../../shared/components/brand/OnPowerLogoIcon';

/**
 * Side Navigation Component for Technician Dashboard
 * @param {Object} props
 * @param {string} props.activeView - Current active view ('today' | 'history')
 * @param {Function} props.onViewChange - Callback when view changes
 * @param {Function} props.onShowActiveUsers - Callback to show active users modal
 * @param {Function} props.onLogout - Callback for logout
 * @param {boolean} props.isMobileOpen - Mobile menu open state
 * @param {Function} props.onMobileToggle - Callback to toggle mobile menu
 */
const SideNav = ({ activeView, onViewChange, onLogout, isMobileOpen, onMobileToggle }) => {

    const menuItems = [
        {
            id: 'today',
            label: 'Tareas del Día',
            icon: CalendarCheck,
            onClick: () => {
                onViewChange('today');
                onMobileToggle(false);
            }
        },
        {
            id: 'history',
            label: 'Historial',
            icon: ClockCounterClockwise,
            onClick: () => {
                onViewChange('history');
                onMobileToggle(false);
            }
        },
        {
            id: 'users',
            label: 'Usuarios Activos',
            icon: Users,
            onClick: () => {
                onViewChange('users');
                onMobileToggle(false);
            }
        },
        {
            id: 'logout',
            label: 'Cerrar Sesión',
            icon: SignOut,
            onClick: () => {
                onLogout();
                onMobileToggle(false);
            },
            danger: true
        }
    ];

    const renderMenuItem = (item) => {
        const Icon = item.icon;
        const isActive = activeView === item.id;

        return (
            <button
                key={item.id}
                onClick={item.onClick}
                className={`
          w-full flex items-center space-x-3 px-4 py-3 rounded-lg
          transition-colors duration-200
          ${isActive
                        ? 'bg-[--app-sidebar-active] text-accent-text'
                        : item.danger
                            ? 'text-error hover:bg-error/12 hover:text-error'
                            : 'text-content-muted hover:bg-ink-3 hover:text-content'
                    }
        `}
            >
                <Icon size={24} weight={isActive ? 'fill' : 'regular'} />
                <span className="font-medium">{item.label}</span>
            </button>
        );
    };

    return (
        <>
            {/* Mobile Backdrop */}
            {isMobileOpen && (
                <div
                    className="md:hidden fixed inset-0 bg-[var(--app-overlay)] z-40"
                    onClick={() => onMobileToggle(false)}
                />
            )}

            {/* Sidebar */}
            <aside
                className={`
          technician-sidenav fixed md:static inset-y-0 left-0 z-50
          w-64 bg-ink-2 border-r border-ink-3
          transform transition-transform duration-300 ease-in-out
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
          flex flex-col
        `}
            >
                {/* Header */}
                <div className="p-4 border-b border-ink-3 flex items-center justify-between">
                    <div className="hidden md:block">
                        <OnPowerLogo className="h-8" />
                    </div>
                    <div className="md:hidden">
                        <OnPowerLogoIcon className="h-8 w-8" />
                    </div>

                    {/* Close button for mobile */}
                    <button
                        onClick={() => onMobileToggle(false)}
                        className="md:hidden text-content-muted hover:text-content transition-colors"
                        aria-label="Cerrar menú"
                    >
                        <X size={24} />
                    </button>
                </div>

                {/* Menu Items */}
                <nav className="flex-1 p-4 space-y-2">
                    <div data-tour="tech-nav" className="space-y-2">
                        {menuItems.filter((item) => ['today', 'history'].includes(item.id)).map(renderMenuItem)}
                    </div>
                    {menuItems.filter((item) => !['today', 'history'].includes(item.id)).map(renderMenuItem)}
                </nav>

                {/* Footer */}
                <div className="p-4 border-t border-ink-3">
                    <p className="text-xs text-muted-deep text-center">
                        Dashboard Técnico
                    </p>
                </div>
            </aside>
        </>
    );
};

export default SideNav;
